<template>
    <vx-card class="limited-max-width" id="pack-offers">
      <div>
        <header-step-process-component
          v-bind:step="step">
        </header-step-process-component>

        <div v-if="dataStored.extraProduct.type == 'RC'">
          <civil-liability-packs
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus">

          </civil-liability-packs>
        </div>
        
        <div v-if="dataStored.extraProduct.type == 'CS'">
          <cyber-security-offer
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus">

          </cyber-security-offer>
        </div>
      </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import CoverageChartComponent from '../components/eprevision-components/coverage-chart/CoverageChartComponent.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
import CivilLiabilityPacks from '../components/eprevision-components/civilLiabilityPacks/CivilLiabilityPacks.vue';
import CyberSecurityOffer from '../components/eprevision-components/cyberSecurityOffer/CyberSecurityOffer.vue';
import axios from '../../http/axios/index.js'
export default {
  components: {
      VxCard,
      HeaderStepProcessComponent,
      CivilLiabilityPacks,
      CoverageChartComponent,
      CyberSecurityOffer
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        next: "extra-products/third",
        previus: "extra-products/first",
        dataStored: null,
        commercialOffer: null,
        dataTablePackage: [],
        packsCoverageChart: null,
        packCoverageChart: null,
        coverageChartPop: false,
      }
    },
    created() {
      this.$vs.loading.close()
  
      this.dataStored = JSON.parse(localStorage.getItem(this.code))
      if(this.dataStored.extraProduct.type == "RC") {

        this.chargeInfo()
      }
      
    },
  	methods: {
      chargeInfo() {
        switch(this.dataStored.initialData.activityType) {
          case "public":
            this.commercialOffer = this.dataStored.offer[0].publicCivilLiabilities
            break;
          case "mixed":
            this.commercialOffer = this.dataStored.offer[0].mixedCivilLiabilities
            break;
          case "private":
            this.commercialOffer = this.dataStored.offer[0].privateCivilLiabilities
            break;
        }
      }, 
    }
}
</script>

 <style lang="scss">
 
// #pack-offers {
//   #buttons .next-button {
//       display: none;
//     }
//       .box-buttons-contract {
//         position: relative;
//       }
// }


//  @media only screen and (min-width : 600px)
//   and (max-width : 760px) {

//   #pack-offers {
//      #buttons .call-button {
//         float: right;
//       }
//       .box-buttons-contract {
//         position: relative;
//       }
//     }
//   }
   
//  @media(min-width: 761px) {

//    #pack-offers {
//       #buttons .call-button button{
//         float:right;

//       }

//       .box-buttons-contract {
//         position: relative;
//       }
//     }
//  }
</style>